// Quick-input suggestion chips for the AI menu. Clicking one fills the prompt
// and focuses the textarea (Enter then submits) — a one-click way to start a
// common request. Two sets: editing a selection vs asking about the company
// (no selection).

export const SELECTION_CHIPS = ['Improve writing', 'Make it concise', 'Fix grammar & spelling', 'Make it more formal', 'Summarize'];

export const COMPANY_CHIPS = [
    'What does this company do?',
    'Key risks to watch',
    'Recent developments',
    'Summarize the financials',
    'Who are the main competitors?',
];

// Compose-only chip — surfaced via AIMenu's extraCompanyChips so it appears in
// the compose-email editor but not the One Pager / Engagement Letter AI dialogs.
export const COMPOSE_PITCH_CHIP = 'Pitch Draft for this Org';

// Chips whose visible label differs from the prompt sent to the agent. A chip
// without an entry here submits its label verbatim (back-compat for the rest).
export const CHIP_PROMPT_MAP: Record<string, string> = {
    'Pitch Draft for this Org':
        'Draft a concise, professional outbound pitch email body for this company — a crisp hook, 2-3 sentences on fit/value, and a clear call to action. Plain prose, no subject line.',
};
